<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Meni items</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <!--<v-data-table
                    class="mt-4"
                    hide-default-footer
                    style="width: 100%;border: 1px solid #ddd;border-radius: 0"
                    :headers="headers"
                    :items="items"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-btn depressed color="primary" small tile :to="{name: 'meni-id-items-create'}">Add new</v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:item.option="{ item }">
                    <v-btn depressed color="primary" small tile @click="edit(item)">Edit</v-btn>
                    <v-btn depressed color="red" dark class="ml-3" small tile @click="remove(item)">Delete</v-btn>
                </template>
            </v-data-table>-->
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Meni Itam</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col class="d-flex mt-3" cols="12">
                    <v-btn depressed color="success" small tile :to="{name: 'meni-id-items-create'}">Add new</v-btn>
                </v-col>
                <v-col cols="12">
                    <v-progress-linear
                            class="my-4"
                            indeterminate
                            color="primary"
                            v-if="loading"
                    ></v-progress-linear>
                    <v-treeview
                            v-if="items.length"
                            open-all
                            :items="items"
                            selection-type="independent"
                            color="success"
                    >
                        <template v-slot:prepend="{ item }">
                            <span class="overline">ID:{{item.id}}</span>
                        </template>
                        <template v-slot:append="{ item, open }">
                           <!-- <v-btn icon :to="{name: 'kategorije-create', params: {item: {parent: {id: item.id, name: item.name}, langs: []}, type: 'news', sub: true}}">
                                <v-icon small>{{'mdi-plus'}}</v-icon>
                            </v-btn>-->
                            <v-btn icon @click="edit(item)">
                                <v-icon small>{{'mdi-pencil'}}</v-icon>
                            </v-btn>
                            <v-btn icon @click="remove(item)">
                                <v-icon small>{{'mdi-delete'}}</v-icon>
                            </v-btn>
                        </template>
                    </v-treeview>
                </v-col>
            </v-row>
        </v-col>


        <v-dialog
                v-model="dialog"
                v-if="selectedItem"
                max-width="800"
        >
            <v-card>
                <v-card-title class="headline">Edit item</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <!--<v-select clearable-->
                                    <!--v-model="selectedItem.position"-->
                                    <!--:items="position"-->
                                    <!--:label="$t('menu.position')"-->
                                    <!--outlined-->
                                    <!--dense-->
                            <!--&gt;</v-select>-->
                            <v-text-field
                                    clearable
                                    v-model="selectedItem.position"
                                    :items="position"
                                    :label="$t('menu.position')"
                                    outlined
                                    dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select clearable
                                    v-model="selectedItem.parent_id"
                                    :items="menuItems"
                                    :label="$t('menu.parent')"
                                    outlined
                                    dense
                                    item-text="name"
                                    item-value="id"
                                    return-object
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <!--<v-select clearable
                                    v-model="selectedItem.category_id"
                                    :items="categoryItems"
                                    :label="$t('menu.pageOfUrl')"
                                    outlined
                                    dense
                                    item-text="name"
                                    item-value="id"
                                    return-object
                            ></v-select>-->
                            <v-autocomplete
                                    clearable
                                    v-model="selectedItem.category"
                                    :items="categoryItems"
                                    outlined
                                    dense
                                    :label="$t('menu.pageOfUrl')"
                                    item-text="name"
                                    item-value="id"
                                    return-object
                            >
                                <template v-slot:item="data">
                                    <v-list-item-content>
                                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                        <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">

                            <v-tabs v-model="tab" background-color="primary" dark height="40">
                                <v-tab v-for="item in selectedItem.langs" :key="item.tab">
                                    {{ item.lang.name }}
                                </v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tab">
                                <v-tab-item v-for="item in selectedItem.langs" :key="item.tab">
                                    <v-card flat>
                                        <v-card-text>
                                            <v-text-field
                                                    v-model="item.name"
                                                    label="Name"
                                                    outlined
                                                    dense
                                            ></v-text-field>
                                            <v-text-field
                                                    v-model="item.url"
                                                    label="URL"
                                                    outlined
                                                    dense
                                            ></v-text-field>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs-items>

                        </v-col>
                    </v-row>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="selectedItem = null, dialog = false">
                        Cancel
                    </v-btn>

                    <v-btn
                            color="green darken-1"
                            tile
                            dark
                            depressed
                            @click="save">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <confirm-dialog ref="confirmBox"></confirm-dialog>
    </v-row>
</template>


<script>
	import bitPage from "../../../../components/layout/page";
    import confirmDialog from '../../../../components/global/confirm'
    import config from '../../../../config'

	export default {
		components: {
			bitPage,
            confirmDialog
		},
		head() {
			return {
                config: config,
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Meni',
					disabled: true
				},
			],
			headers: [
				{text: 'ID', value: 'id'},
				{text: 'Name', value: 'name'},
				{text: 'Option', value: 'option'}
			],
			items: [],
			dialog: false,
			tab: 0,
			selectedItem: null,
			position: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
			categoryItems: [],
			menuItems: [],
            loading: false
		}),
		created() {
			this.getDoc();
			this.getCategory();
			this.getMenuItem();
		},
		methods: {
			save() {
				let data = {
                    group: this.selectedItem.category.group,
                    group_id: parseInt(this.selectedItem.category.id.replace("c", "").replace("o", "")),

					parent_id: this.selectedItem.parent_id,
					position: this.selectedItem.position,
					langs: this.selectedItem.langs,
                    menu_id: this.$route.params.id
				};
				this.axios.put(`/menu-item/${this.selectedItem.id}`, data)
				.then(res => {
					this.dialog = false;
					let index = this.items.findIndex(item => item.id === this.selectedItem.id);
					console.log(index);
					this.selectedItem = null;
					this.items[index] = res.data;
				})
			},
			getMenuItem() {
				this.menuItems = [];
				this.axios.get(`/menu-item`)
				.then(res => {
					res.data.forEach(item => {
						let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                        item['name'] = lang && lang.name ? lang.name : '';
						if (item['name'] !== '') this.menuItems.push(item)
					})
				})

                console.log(this.menuItems)
			},
			getCategory() {

                //this.categoryItems.push({ header: 'Object' });
                this.axios.get(`${config.apiUrl}/object/all`).then(res => {
                    res.data.forEach(item => {
                        let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang)
                        item['name'] = lang && lang.name ? lang.name : '';
                        item['group'] = 'Object'
                        item['id'] = item.id + 'o'
                        if(item['name'] !== '') this.categoryItems.push(item)
                    })
                })
                .then(() => {
                    //this.categoryItems = [{ header: 'Category' }];
                    this.axios.get(`${config.apiUrl}/category/all`).then(res => {
                        res.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang)
                            item['name'] = lang && lang.name ? lang.name : '';
                            item['group'] = 'Category'
                            item['id'] = item.id + 'c'
                            if(item['name'] !== '') this.categoryItems.push(item)
                        })
                    })
                })
			},
			getDoc() {
			    this.loading = true;
				this.items = [];
				this.axios.get(`/menu2/${this.$route.params.id}`)
				.then(res => {
					res.data.menu_items.forEach(item => {
						let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                        item['name'] = lang && lang.name ? lang.name : '';
                        if (item.children) this.loop(item.children);
						//if (item['name'] !== '') this.items.push(item)
						this.items.push(item)
					})
				}).then(() => {
				    this.loading = false
                })
			},
            loop(items) {
                items.forEach(item => {
                    let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                    item['name'] = lang && lang.name ? lang.name : '';
                    if (item.children) this.loop(item.children)
                })
            },
			edit(item) {
				this.selectedItem = item;
                this.selectedItem.itemable.group = this.selectedItem.itemable_type
                this.selectedItem.category = this.selectedItem.itemable

                if(this.selectedItem.itemable_type === 'Category') this.selectedItem.category.id = this.selectedItem.itemable_id + 'c'
                if(this.selectedItem.itemable_type === 'Object') this.selectedItem.category.id  = this.selectedItem.itemable_id + 'o'


                this.$store.dispatch('GET_LANGUAGES').then(res => {
                    res.forEach(lang => {
                        let check = this.selectedItem.langs.find(item => item.lang_id === lang.id)
                        if(!check) {
                            this.selectedItem.langs.push({
                                name: null,
                                seo_url: null,
                                meta_description: null,
                                keywords: null,
                                short_description: null,
                                description: null,
                                lang: lang,
                                lang_id: lang.id
                            })
                        }
                    })
                })

				this.dialog = true;
			},
            remove(item) {
                this.$refs.confirmBox.open('Remove menu item', 'Are you sure want to delete this menu item?')
                    .then(() => this.axios.delete(`/menu-item/${item.id}`).then(() => {
                        this.items.splice(this.items.indexOf(item), 1)
                    }))
            }
		},
		computed: {
			setLang() {
				return this.$store.state.lang.code === 'en'
					? 'en' : this.$store.state.lang.code === 'la'
						? 'sr' : 'ћи'
			}
		},
		watch: {
			setLang() {
				this.getDoc();
				this.getMenuItem();
				this.getCategory();
			}
		}

	}
</script>
